import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import Table from "../../../../../core/pagination/datatable";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Edit, RotateCcw } from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
// import EditHoliday from "./Edit";
import AddHoliday from "./Add";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import { Select, Spin, Switch } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import EditHoliday from "./Edit";
import Bell from "feather-icons-react/build/IconComponents/Bell";
import SendNotification from "./SendNotification";

const RollcallHolidaysList = () => {
  const currentYear = new Date().getFullYear();
  const [editObj, setEditObj] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [loading, setLoading] = useState(true);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [holidaydata, setholidayData] = useState([]);
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showNotify, setShowNotify] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const years = [currentYear - 1, currentYear, currentYear + 1];

  const fetchdata = async () => {
    if ((superIdData, tokenData)) {
      setLoading(true);
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/holidays/getholidays?superid=${superIdData}&year=${selectedYear}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const data = await response.json();

        if (data.status) {
          setholidayData(data.ResultData);
          console.log("Holiday Data:", data.ResultData);
        } else {
          console.error("Error fetching data:", data.Message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredData = (holidaydata || []).sort(
    (a, b) => b.isactive - a.isactive,
  );

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchdata();
    }
  }, [selectedYear, tokenData, superIdData]);

  useEffect(() => {
    console.log("Current editObj:", editObj);
  }, [editObj]);

  const columns = [
    {
      title: "Date",
      dataIndex: "HolidayDt",
      sorter: (a, b) => new Date(a.HolidayDt) - new Date(b.HolidayDt),
      render: (text) => {
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },

    {
      title: "Day",
      dataIndex: "HolidayDt",
      sorter: (a, b) => new Date(a.HolidayDt) - new Date(b.HolidayDt),
      render: (text) =>
        new Date(text).toLocaleDateString("en-US", { weekday: "long" }),
    },
    {
      title: "Reason",
      dataIndex: "Reason",
      sorter: (a, b) => a.Reason?.length - b.Reason?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Optional",
      dataIndex: "Optional",
      render: (optional) => (
        <Switch checked={optional === true} disabled size="small" />
      ),
    },
    {
      title: "Repeat Yearly",
      dataIndex: "IsYearly",
      render: (IsYearly) => (
        <Switch checked={IsYearly === true} disabled size="small" />
      ),
    },
  ];

  if (perm?.Delete) {
    columns.push({
      title: "Status",
      dataIndex: "isactive",
      sorter: (a, b) => a.isactive - b.isactive,
      key: "status",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          style={{
            transform: "scale(0.8)",
            transformOrigin: "left center",
          }}
          onChange={() => {
            handleDeleteConfirmation(record.holidayid);
          }}
        />
      ),
    });
  }

  columns.push({
    title: "Action",
    dataIndex: "action",
    align: "center",
    render: (__, record) => (
      <div className="action-table-data d-flex justify-content-center">
        <div className="edit-delete-action">
          {perm?.Write && (
            <>
              <Link
                className="me-2 p-2"
                onClick={() => {
                  handelShowEdit(record);
                }}
              >
                <Edit className="feather-edit text-info" />
              </Link>
            </>
          )}
          <Link
            className=" p-2"
            onClick={() => {
              setShowNotify(true);
            }}
          >
            <Bell className="feather-edit"></Bell>
          </Link>

          {/* <Link
              className="confirm-text p-2 me-2"
              to="#"
              onClick={() => handleDeleteConfirmation(record.holidayid)}
            >
              <Trash2 className="feather-trash-2 text-danger" />
            </Link> */}
        </div>
      </div>
    ),
  });

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDeleteConfirmation = (holidayId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Action it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/holidays/deleteholiday`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
              body: JSON.stringify({ holidayid: holidayId }),
            },
          );

          const responseData = await response.json();

          if (responseData.status) {
            Swal.fire({
              title: "Success",
              text: "Holiday Action successfully",
              icon: "success",
            }).then(() => {
              fetchdata();
            });
          } else {
            Swal.fire("Error", "Failed to delete the holiday.", "error");
          }
        } catch (error) {
          console.error("Error deleting holiday:", error);
          Swal.fire("Error", "Failed to delete the holiday.", "error");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your item is safe :)", "info");
      }
    });
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData?.map((item, index) => ({
      "S.No": index + 1,
      Date: formatDate(item.HolidayDt),
      Reason: item.Reason,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Holidays");
    XLSX.writeFile(wb, "Holidays.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.setProperties({
      title: "Holidays Report",
      author: "Your Application",
      creator: "Your Application",
    });

    const headers = ["S.no", "Date", "Reason"];
    const tableData = filteredData?.map((item, index) => [
      index + 1,
      formatDate(item.HolidayDt),
      item.Reason,
    ]);

    doc.autoTable({ head: [headers], body: tableData });
    doc.save("Holidays.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Holidays
                    </h4>
                  </ol>
                </nav>
                <h6>Manage holidays</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#offcanvasRightAddHoliday"
                  // aria-controls="offcanvasRightAddHoliday"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {/* /product list */}
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="col-6" style={{ width: 140 }}>
                    <Select
                      placeholder="Year"
                      style={{ width: 120, height: 37 }}
                      value={selectedYear}
                      onChange={(value) => {
                        setSelectedYear(value);
                      }}
                    >
                      {years?.map((year) => (
                        <Select.Option key={year} value={year}>
                          {year}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive brand-table">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={filteredData}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>

      <AddHoliday
        isOpen={showAdd}
        fetchdata={fetchdata}
        onClose={() => setShowAdd(false)}
      />
      <EditHoliday
        isOpen={showEdit}
        editObj={editObj}
        fetchdata={fetchdata}
        onClose={() => setShowEdit(false)}
      />
      <SendNotification
        isOpen={showNotify}
        onClose={() => setShowNotify(false)}
      />
    </div>
  );
};

export default RollcallHolidaysList;
